import React from "react";
import { Card, CardContent, CardHeader, Collapse, Divider } from "@mui/material";

import AddressModule from "../Adresse";

export default function ProfileAddressesCard({ open, onToggle, profileData, addressErrors, onAddressChange }) {
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: "0 8px 28px rgba(0,0,0,0.06)",
        mb: 3,
      }}
    >
      <CardHeader
        title="Adressen"
        subheader="Geschaeftssitz, Rechnungs- und Leistungsorte"
        action={onToggle()}
      />
      <Collapse in={open} timeout="auto">
        <Divider />
        <CardContent>
          <AddressModule
            onAddressChange={onAddressChange}
            addresses={profileData.addresses || []}
            validationErrors={addressErrors}
          />
        </CardContent>
      </Collapse>
    </Card>
  );
}
